'use strict';
import Vue from 'vue'
import Vuex from "vuex"


Vue.use(Vuex);


const store = new Vuex.Store(
    {
        state: {
            authenticated: false,
            token: '',
        },
        mutations: {
            setAuthentication(state, payload) {
                state.authenticated = payload.status;
                state.token = payload.token;
            },
            unsetAuthentication(state) {
                state.authenticated = false;
                state.token = '';
            }
        },
        actions: {
        },
    }
)

export default store
